<template>
	<div id="page">

		<div class="page-content">
			<div class="page-title page-title-small">
				<h2>
					<button @click.prevent="goBack"><i class="fa fa-arrow-right"></i></button>
					زمان سنج (تایمر)
					<button data-menu="HelpMenu" class="position-static mr-1"><i class="fa fa-question-circle helpIco"></i></button>
				</h2>
				<button class="bg-fade-gray1-dark shadow-xl d-flex align-items-center justify-content-center refresh-btn" @click.prevent="reloadPage"><i class="font-16 fa fa-redo"></i></button>
			</div>

			<div class="card card-style mb-2">
				<div class="row m-0 p-3">
					<div class="col-12 pr-0 pl-1">
						<div class="input-style input-style-2 input-required has-icon m-0">
							<i class="input-icon fa fa-filter color-orange-dark"></i>
							<em><i class="fa fa-angle-down"></i></em>
							<select class="form-control" v-model="filterId" autocomplete="off" @change="filterList">
								<option selected value="1">درحال انجام</option>
								<option value="2">پایان یافته</option>
								<option value="3">همه موارد</option>
							</select>
						</div>
					</div>
				</div>
			</div>
			<div class="card header-card shape-rounded" data-card-height="150">
				<div class="card-overlay bg-highlight opacity-95"></div>
				<div class="card-overlay dark-mode-tint"></div>
				<div class="card-bg bg-20"></div>
			</div>
			<span data-menu="menu-language" class="optionMenu"></span>


			<!--<div class="card card-style mb-2 p-3 overflow-visible z-index1000">
				<div class="d-flex justify-content-start">
					<div class="w-100 search-box search-color bg-magenta1-light rounded-m position-relative">
						<i class="fa fa-search pr-3"></i>
						<input type="text" class="border-0" placeholder="جستجو ..." data-search="" v-model="searchKey" @change="filterList">
					</div>
				</div>
			</div>-->

			<div :class="{'bg-Start' : item.lastStatus ,'bg-Regist' : item.regist}" class="verticalListCol" v-for="item in WorkTimerList" :key="item.id">
				<div class="timerTitel d-flex justify-content-between rounded-sm font-900 p-2 w-100 mb-2 text-white">
					<span class="font-weight-bold">{{item.title}} ({{item.folderCount}})</span>
					<span @click.stop="showMenu(item)" class="text-center" style="width:25px"><i class="fa fa-ellipsis-v font-14"></i></span>
				</div>
				<ul class="list-group list-group-flush rounded-sm">
					<li class="list-group-item p-2">
						تاریخ ایجاد: <b class="d-inline-block text-left ltr float-left">{{item.createDateFa}}</b>
					</li>
					<li v-if="item.lastUpdateDateTimeFa!=null" class="list-group-item p-2">
						زمان ثبت آخرین تغییرات:<b class="d-inline-block text-left ltr float-left"> {{item.lastUpdateDateTimeFa}}</b>
					</li>
					<li v-if="item.startDateTimeFa!=null" class="list-group-item p-2">
						زمان شروع:<b class="d-inline-block text-left ltr float-left"> {{item.startDateTimeFa}}</b>
					</li>
					<li v-if="item.endDateTimeFa!=null" class="list-group-item p-2">
						زمان پایان:<b class="d-inline-block text-left ltr float-left"> {{item.endDateTimeFa}}</b>
					</li>
					<li v-if="item.workTime!=null" class="list-group-item p-2">
						زمان استفاده شده:<b class="d-inline-block text-left ltr float-left"> {{item.workTime}}</b>
					</li>
					<li v-if="item.lastStatus" class="list-group-item p-2 text-center">
						{{GetDatediffBetweenTheseTwoTimes(item,true)}}
						<b class="d-inline-block text-left ltr TimeCunter" id="TimeCunter"></b>
					</li>
				</ul>


				<div v-if="!item.regist">

					<button v-if="!item.lastStatus" @click="StartTimeWorkTimer(item)" type="button" class="btn btn-xxs mt-2 btn-full bg-warning text-white rounded-sm font-900 w-100"><i class="fa fa-play font-10 ml-2"></i>شروع</button>

					<button v-else type="button" @click="StopTimeWorkTimer(item)" class="btn btn-xxs mt-2 btn-full bg-red1-dark rounded-sm font-900 w-100"><i class="fa fa-pause font-10 ml-2"></i>توقف</button>

				</div>
				<div v-else class="finished-box">
					<span class="i-bg">
						<i class="fa fa-hourglass-end"></i>
					</span>
					<b class="font-weight-bold">پایان یافته است</b>
				</div>

			</div>

			<div class="card card-style" v-if="Loading">
				<div class="content">
					<div class="d-flex justify-content-center w-100 py-5">
						<div class="spinner-border color-magenta2-dark" role="status"></div>
					</div>
				</div>
			</div>
			<div class="card card-style" v-if="WorkTimerList.length==0 && Loading==false">
				<div class="content">
					<div class="text-center"><i class="fa fa-exclamation-triangle text-warning fa-3x"></i></div>
					<p class="text-center py-3">زمانسنجی یافت نشد.</p>
				</div>
			</div>


		</div>
		<transition enter-active-class="animated bounceInUp" leave-active-class="animated bounceOutDown">
			<div v-show="pageLoaded==true" class="addBtn" id="addBtn" ref="addBtn" :style="{top:addButtonTop}">
				<router-link to="/CreateTaskNote" class="btn px-3 py-2  rounded-xl bg-green2-light font-900 text-white shadow-xl border-green2-dark">
					<i class="fa fa-plus font-14"></i>
				</router-link>
			</div>
		</transition>
		<transition enter-active-class="animated fadeInUp" leave-active-class="animated fadeOutDown">
			<div v-if="Loading==true" class="w-100 d-flex justify-content-center loadingBox">
				<div class="toast-tiny toast-bottom bg-magenta1-light fade show text-center font-10"><i class="fa fa-sync fa-spin ml-3"></i>درحال دریافت اطلاعات ...</div>
			</div>
		</transition>
		<transition enter-active-class="animated bounceInUp" leave-active-class="animated bounceOutDown">
			<div v-show="pageLoaded==true" class="addBtn" id="addBtn" ref="addBtn" :style="{top:addButtonTop}">
				<router-link to="/AddOrEditWorkTimer" class="btn px-3 py-2  rounded-xl bg-green2-light font-900 text-white shadow-xl border-green2-dark">
					<i class="fa fa-plus font-14"></i>
				</router-link>
			</div>
		</transition>
		<div id="menu-language" class="menu menu-box-bottom menu-box-detached rounded-m" data-menu-effect="menu-over" style="display: block;">
			<div class="m-3">
				<div class="list-group list-custom-small">
					<router-link :to="{ name: 'AddOrEditWorkTimer', params: { id: itemId  } }" v-if="regist" class="d-flex justify-content-between align-items-center bg-white p-0"><span class="d-inline-flex align-items-center"><i class="fa fa-search color-yellow1-light float-right font-14"></i>مشاهده</span><i class="fa fa-angle-left"></i></router-link>
					<!--<button v-if="lastFolderId!=null" class="d-flex justify-content-between align-items-center bg-white p-0"><span class="d-inline-flex align-items-center"><i class="fa fa-paperclip color-red1-light float-right font-14"></i>افزودن ضمیمه</span><i class="fa fa-angle-left"></i></button>
					<button v-if="lastFolderId!=null" class="d-flex justify-content-between align-items-center bg-white p-0"><span class="d-inline-flex align-items-center"><i class="fa fa-paperclip color-red1-light float-right font-14"></i>ضمائم</span><i class="fa fa-angle-left"></i></button>-->
					<router-link :to="{ name: 'AddOrEditWorkTimer', params: { id: itemId  } }" v-if="!regist" class="d-flex justify-content-between align-items-center bg-white p-0"><span class="d-inline-flex align-items-center"><i class="fa fa-edit color-green2-light float-right font-14"></i>ویرایش</span><i class="fa fa-angle-left"></i></router-link>
					<button v-if="!regist" class="d-flex justify-content-between align-items-center bg-white p-0" @click="RegistWorkTimer"><span class="d-inline-flex align-items-center"><i class="fa fa-hourglass-end color-blue1-dark float-right font-14"></i>اتمام</span><i class="fa fa-angle-left"></i></button>
					<button v-if="!regist" class="d-flex justify-content-between align-items-center bg-white p-0" @click="DeleteWorkTimer"><span class="d-inline-flex align-items-center"><i class="fa fa-trash color-red1-light float-right font-14"></i>حذف</span><i class="fa fa-angle-left"></i></button>
					<button v-if="regist && otherWorkId==null" class="d-flex justify-content-between align-items-center bg-white p-0" @click="WorkTimerInsertOtherWork"><span class="d-inline-flex align-items-center"><i class="fa fa-list-alt color-magenta2-light float-right font-14"></i>صدور فعالیت بر مبنای زمان سنج</span><i class="fa fa-angle-left"></i></button>
				</div>
				<div class="clear"></div>
			</div>
		</div>
		<Help-Menu title="معرفی موبایل اپلیکیشن تسکینو" keyEn="TaskList"></Help-Menu>
	</div>
	<Create-OtherWork v-if="openCreateOtherWorkModal" v-bind:ItemId="itemId" @close="CloseCreateOtherWorkModal"></Create-OtherWork>



</template>

<script>
	import VueSimpleAlert from "vue3-simple-alert";
	import HelpMenu from '../Components/HelpMenu.vue';
	import CreateOtherWork from '../Components/CreateOtherWork.vue';
	export default {
		components: {
			"Help-Menu": HelpMenu,
			"Create-OtherWork": CreateOtherWork
		},
		data() {
			return {
				openCreateOtherWorkModal: false,
				regist: false,
				filterId: 1,
				lastFolderId: null,
				otherWorkId: null,
				itemId: 0,
				pageLoaded: false,
				polling: null
			};
		},
		computed: {
			WorkTimerList() {
				return this.$store.getters.GetWorkTimerList;
			},
			Loading() {
				return this.$store.getters.GetLoading;
			},
		},
		beforeRouteLeave(to, from) {
			clearInterval(this.polling)
		},
		created() {
			this.$store.dispatch("GetWorkTimerListFromServer", {
				status: this.filterId,
			});
		},
		mounted() {
			this.showAddButton();
			try {
				this.polling = setInterval(function () {
					let h = 0;
					let m = 0;
					let s = 0;
					let time = [];
					let t = document.getElementById("TimeCunter");
					console.log(t);
					if (t != null) {
						time = t.innerText.split(":");
						h = parseInt(time[0])
						m = parseInt(time[1])
						s = parseInt(time[2])
						s = s + 1;
						if (s >= 60) {
							s = 0;
							m = m + 1;
						}
						if (m >= 60) {
							m = 0;
							h = h + 1;
						}
						t.innerText = h.toString().padStart(2, '0') + ":" + m.toString().padStart(2, '0') + ":" + s.toString().padStart(2, '0');
					} else {
						clearInterval(this.polling);
					}
				}, 1000);
			} catch (e) {

				clearInterval(this.polling);
			}
			document.querySelectorAll(".menu-box-right").forEach(a => a.style.display = "block");
		},
		activated() {
			this.showAddButton();
		},
		methods: {
			filterList() {
				this.$store.dispatch("GetWorkTimerListFromServer", {
					status: this.filterId,
				});
			},
			CloseCreateOtherWorkModal() {
				this.openCreateOtherWorkModal = false;
			},
			showAddButton() {
				this.pageLoaded = true;

			},
			showMenu(item) {
				this.regist = item.regist;
				this.otherWorkId = item.otherWorkId;
				this.itemId = item.id;
				this.lastFolderId = item.lastFolderId;
				document.getElementsByClassName("optionMenu")[0].click();
			},
			StartTimeWorkTimer(item) {
				this.$http
					.get(
						"WorkTimer/StartTime?id=" +
						item.id
					)
					.then((data) => {
						if (data.data.isSuccess) {
							clearInterval(this.polling)
							this.$store.dispatch("GetWorkTimerListFromServer", {
								status: this.filterId,
							});

						} else {
							this.showErrorMessage(data.data.message);
						}
					})
			},
			StopTimeWorkTimer(item) {
				this.$http
					.get(
						"WorkTimer/StopTime?id=" +
						item.id
					)
					.then((data) => {
						if (data.data.isSuccess) {
							clearInterval(this.polling);
							this.$store.dispatch("GetWorkTimerListFromServer", {
								status: this.filterId,
							});
						} else {
							this.showErrorMessage(data.data.message);
						}
					})
			},
			DeleteWorkTimer() {
				document.getElementsByClassName('menu-hider')[0].click();
				VueSimpleAlert.confirm("آیا مایل به حذف این مورد هستید؟", null, "question", { confirmButtonText: "تایید", cancelButtonText: "انصراف" }).then(() => {
					this.$http
						.get(
							"WorkTimer/Delete?id=" +
							this.itemId
						)
						.then((data) => {
							if (data.data.isSuccess) {
								clearInterval(this.polling)
								this.$store.dispatch("GetWorkTimerListFromServer", {
									status: this.filterId,
								});
							} else {
								this.showErrorMessage(data.data.message);
							}
						})
				});
			},
			RegistWorkTimer() {
				document.getElementsByClassName('menu-hider')[0].click();
				VueSimpleAlert.confirm("آیا مایل به اتمام این مورد هستید؟", null, "question", { confirmButtonText: "تایید", cancelButtonText: "انصراف" }).then(() => {
					//Regist
					this.$http
						.get(
							"WorkTimer/Regist?id=" +
							this.itemId
						)
						.then((data) => {
							if (data.data.isSuccess) {
								clearInterval(this.polling)
								this.$store.dispatch("GetWorkTimerListFromServer", {
									status: this.filterId,
								});
							} else {
								this.showErrorMessage(data.data.message);
							}
						})
				});
			},
			WorkTimerInsertOtherWork() {
				document.getElementsByClassName('menu-hider')[0].click();
				this.openCreateOtherWorkModal = true;
			},
			GetDatediffBetweenTheseTwoTimes(item) {
				this.$http
					.get(
						"WorkTimer/GetDatediffBetweenTheseTwoTimes?startDate=" +
						item.startDateTime
					)
					.then((data) => {
						document.getElementById("TimeCunter").innerText = data.data;
						clearInterval(this.polling);
						this.polling = setInterval(function () {
							let h = 0;
							let m = 0;
							let s = 0;
							let time = [];
							let t = document.getElementById("TimeCunter");
							time = t.innerText.split(":");
							h = parseInt(time[0])
							m = parseInt(time[1])
							s = parseInt(time[2])
							s = s + 1;
							if (s >= 60) {
								s = 0;
								m = m + 1;
							}
							if (m >= 60) {
								m = 0;
								h = h + 1;
							}
							t.innerText = h.toString().padStart(2, '0') + ":" + m.toString().padStart(2, '0') + ":" + s.toString().padStart(2, '0');
						}, 1000);
					});
			}
		}
	
	};
</script>
